import styled from "styled-components";
import DocumentCard from "./DocumentCard";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .header {
    font-weight: 800;
    font-size: 25px;
    width: 100%;
    text-align: left;
  }

  .formContainer {
    max-width: 500px;
    width: 100%;
    margin-top: 3%;
  }

  .buttonContainer {
    width: 100%;
    max-width: 800px;
    text-align: right;
    margin-top: 15px;
  }
`;

const DocumentsContainer = ({ documentsList }) => {
  const documents = [
    {
      documentName: "Privacy Policy",
      documentURL: "https://tactivewealth.com/disclosures/",
      id: 1,
    },
    {
      documentName: "ADV",
      documentURL: "https://tactivewealth.com/disclosures/",
      id: 2,
    },
    {
      documentName: "Form CRS",
      documentURL: "https://tactivewealth.com/disclosures/",
      id: 3,
    },
  ];

  return (
    <>
      <BodyWrapper>
        <div className="header">Documents</div>
        <div className="formContainer">
          {documents.map((document) => (
            <DocumentCard document={document} key={document.id} />
          ))}
          {documentsList.map((document) => (
            <DocumentCard document={document} key={document.id} />
          ))}
        </div>
      </BodyWrapper>
    </>
  );
};

export default DocumentsContainer;
